import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MuiAccordionContent } from './mui-accordion-content.component';
import { MuiAccordionGroup } from './mui-accordion-group.component';
import { MuiAccordionHeader } from './mui-accordion-header.component';
import { MuiAccordion } from './mui-accordion.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    MuiAccordion,
    MuiAccordionHeader,
    MuiAccordionContent,
    MuiAccordionGroup
  ],
  exports: [
    MuiAccordion,
    MuiAccordionHeader,
    MuiAccordionContent,
    MuiAccordionGroup
  ]
})

export class MuiAccordionModule {}
